import React from 'react';
import { User, Mail, Phone, Car, MapPin, Sparkles } from 'lucide-react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { vehicleTypes } from '../../utils/mock';

const CustomerInfoSection = ({ formData, handleInputChange, handleSelectChange, loyaltyStatus }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="name" className="text-white flex items-center space-x-2">
          <User className="w-4 h-4 text-red-500" />
          <span>Full Name *</span>
        </Label>
        <Input
          id="name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
          placeholder="John Doe"
          className="bg-zinc-800 border-zinc-700 text-white placeholder:text-gray-500"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email" className="text-white flex items-center space-x-2">
          <Mail className="w-4 h-4 text-red-500" />
          <span>Email *</span>
        </Label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleInputChange}
          required
          placeholder="john@example.com"
          className="bg-zinc-800 border-zinc-700 text-white placeholder:text-gray-500"
        />
        {/* Loyalty Status Banner */}
        {loyaltyStatus?.exists && (
          <div className="mt-2 p-3 bg-gradient-to-r from-amber-900/30 to-yellow-900/20 border border-amber-500/50 rounded-lg">
            <p className="text-amber-400 text-sm font-semibold flex items-center gap-2">
              <Sparkles className="w-4 h-4" />
              {loyaltyStatus.message}
            </p>
            <p className="text-gray-300 text-xs mt-1">
              {loyaltyStatus.total_bookings} booking{loyaltyStatus.total_bookings !== 1 ? 's' : ''} • ${loyaltyStatus.total_spent.toFixed(2)} lifetime value
            </p>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone" className="text-white flex items-center space-x-2">
          <Phone className="w-4 h-4 text-red-500" />
          <span>Phone *</span>
        </Label>
        <Input
          id="phone"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleInputChange}
          required
          placeholder="236-335-7663"
          className="bg-zinc-800 border-zinc-700 text-white placeholder:text-gray-500"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="vehicleType" className="text-white flex items-center space-x-2">
          <Car className="w-4 h-4 text-red-500" />
          <span>Vehicle Type *</span>
        </Label>
        <Select
          value={formData.vehicleType}
          onValueChange={(value) => handleSelectChange('vehicleType', value)}
          required
        >
          <SelectTrigger className="bg-zinc-800 border-zinc-700 text-white">
            <SelectValue placeholder="Select vehicle type" />
          </SelectTrigger>
          <SelectContent className="bg-zinc-800 border-zinc-700">
            {vehicleTypes.map((type) => (
              <SelectItem key={type} value={type} className="text-white hover:bg-zinc-700">
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Address - Full Width */}
      <div className="md:col-span-2 space-y-2">
        <Label htmlFor="address" className="text-white flex items-center space-x-2">
          <MapPin className="w-4 h-4 text-red-500" />
          <span>Service Address *</span>
        </Label>
        <Input
          id="address"
          name="address"
          value={formData.address}
          onChange={handleInputChange}
          required
          placeholder="123 Main St, City, Province"
          className="bg-zinc-800 border-zinc-700 text-white placeholder:text-gray-500"
        />
      </div>
    </div>
  );
};

export default CustomerInfoSection;
